import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './FaqSection.css';

const ITEM_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

/**
 * "Frequently asked questions" landing section — a clean, centered, single-column
 * accordion. Content is static and sourced from the bundled i18n translations
 * (en/he/ar). RTL-aware; see FaqSection.css for scoped styles.
 */
const FaqSection: React.FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) =>
    setOpenIndex((current) => (current === index ? -1 : index));

  return (
    <section className="faq-section">
      <div className="faq-section__content">
        <header className="faq-section__header">
          <h2 className="faq-section__title">{t('landingSections.faq.title')}</h2>
          <p className="faq-section__subtitle">{t('landingSections.faq.subtitle')}</p>
        </header>

        <ul className="faq-section__list">
          {ITEM_KEYS.map((key, index) => {
            const isOpen = openIndex === index;
            return (
              <li
                key={key}
                className={`faq-item${isOpen ? ' faq-item--open' : ''}`}
              >
                <button
                  type="button"
                  className="faq-item__head"
                  aria-expanded={isOpen}
                  onClick={() => toggle(index)}
                >
                  <span className="faq-item__q">
                    {t(`landingSections.faq.items.${key}.q`)}
                  </span>
                  <span className="faq-item__icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </button>
                <div className="faq-item__body">
                  <div className="faq-item__body-inner">
                    <p>{t(`landingSections.faq.items.${key}.a`)}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default FaqSection;
